/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const CakeIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <path
        data-color="color-2"
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        d="M16,8 c1.104,0,2-0.896,2-2s-2-4-2-4s-2,2.896-2,4S14.896,8,16,8z"
      />
      <path
        data-color="color-2"
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        d="M7,9 c1.104,0,2-0.896,2-2S7,3,7,3S5,5.896,5,7S5.896,9,7,9z"
      />
      <path
        data-color="color-2"
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        d="M25,9 c1.104,0,2-0.896,2-2s-2-4-2-4s-2,2.896-2,4S23.896,9,25,9z"
      />
      <path
        data-cap="butt"
        data-color="color-2"
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeMiterlimit={10}
        d="M21,20c0,2.761-2.239,5-5,5 s-5-2.239-5-5"
      />
      <path
        data-cap="butt"
        data-color="color-2"
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeMiterlimit={10}
        d="M11,20c0,2.761-2.239,5-5,5 s-5-2.239-5-5"
      />
      <path
        data-cap="butt"
        data-color="color-2"
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeMiterlimit={10}
        d="M31,20c0,2.761-2.239,5-5,5 s-5-2.239-5-5"
      />
      <rect
        x={1}
        y={20}
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        width={30}
        height={11}
      />
      <polyline
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        points="27,20 27,13 5,13 5,20 "
      />
    </svg>
  );
};
